import {
  SET_HERO_BANNER,
  SET_HERO_BANNERS,
  SET_FEATURED,
  SET_FEATURE_STATUS,
  SET_OFFERS,
  SET_PROMOS,
  SET_EVENTS,
  SET_MOVIES,
  SET_MERCHANTS,
  SET_MALLS,
  SET_CMS_MALLS,
  SET_MARKETING_CONTENT_DATA,
  SET_MARKETING_CONTENT_STATUS,
  SET_MERCHANTS_LIST_MODAL_DATA,
  SET_STORE_MODAL_DATA,
  SET_DEVICE_LOCATION,
  SET_CURRENT_MALL_IN_MODAL,
  SET_OUR_MALL_MODAL_STATUS,
  SET_CARD_LIST_MODAL_DATA,
  SET_CARD_LIST_MODAL_STATUS,
  SET_CINEMAS,
  SET_PASYAL_ARTICLES,
  SET_HERO_BANNER_PROMOS_AND_EVENTS,
} from './actions/types'

const INITIAL_STATE = {
  heroBanner: null,
  heroBannerPromosAndEvents: null,
  heroBanners: [],
  featured: [],
  featureStatus: null,
  offers: [],
  promos: [],
  events: [],
  movies: [],
  merchants: [],
  malls: [],
  cmsMalls: [],
  cinemas: [],
  showMarketingContentModal: false,
  showMerchantsListModal: false,
  marketingContentModalData: {},
  marketingContentModalStatus: null,
  merchantsListModalData: [],
  showStoreModal: false,
  storeModalData: {},
  deviceLocation: null,
  currentMallInModal: null,
  showOurMallModal: false,
  ourMallModalStatus: null,
  showCardListModal: false,
  cardListModalData: [],
  cardListModalStatus: null,
  pasyalArticles: [],
}

const setHeroBanner = (state, action) => ({
  ...state,
  heroBanner: action.payload.heroBanner,
})

const setHeroBannerPromosAndEvents = (state, action) => ({
  ...state,
  heroBannerPromosAndEvents: action.payload.heroBannerPromosAndEvents,
})

const setHeroBanners = (state, action) => ({
  ...state,
  heroBanners: action.payload.heroBanners,
})

const setFeatured = (state, action) => ({
  ...state,
  featured: action.payload.featured,
})

const setFeatureStatus = (state, action) => ({
  ...state,
  featureStatus: action.payload.featureStatus,
})

const setOffers = (state, action) => ({
  ...state,
  offers: action.payload.offers,
})

const setPromos = (state, action) => ({
  ...state,
  promos: action.payload.promos,
})

const setEvents = (state, action) => ({
  ...state,
  events: action.payload.events,
})

const setMovies = (state, action) => ({
  ...state,
  movies: action.payload.movies,
})

const setMerchants = (state, action) => ({
  ...state,
  merchants: action.payload.merchants,
})

const setMalls = (state, action) => ({
  ...state,
  malls: action.payload.malls,
})

const setCinemas = (state, action) => ({
  ...state,
  cinemas: action.payload.cinemas,
})

const setCMSMalls = (state, action) => ({
  ...state,
  cmsMalls: action.payload.cmsMalls,
})

const setMarketingContentModalData = (state, action) => ({
  ...state,
  marketingContentModalData: action.payload.marketingContentModalData,
})

const setMarketingContentModalStatus = (state, action) => ({
  ...state,
  showMarketingContentModal:
    action.payload.marketingContentModalStatus !== null,
  marketingContentModalStatus: action.payload.marketingContentModalStatus,
})

const setMerchantsListModalData = (state, action) => ({
  ...state,
  showMerchantsListModal: !!action.payload.merchantsListModalData.length,
  merchantsListModalData: action.payload.merchantsListModalData,
})

const setStoreModalData = (state, action) => ({
  ...state,
  showStoreModal: action.payload.storeModalData !== null,
  storeModalData: action.payload.storeModalData,
})

const setDeviceLocation = (state, action) => ({
  ...state,
  deviceLocation: {
    latitude: action.payload.deviceLocation.coords.latitude,
    longitude: action.payload.deviceLocation.coords.longitude,
  },
})

const setCurrentMallInModal = (state, action) => ({
  ...state,
  currentMallInModal: action.payload.currentMallInModal,
})

const setOurMallModalStatus = (state, action) => ({
  ...state,
  showOurMallModal: action.payload.ourMallModalStatus !== null,
  ourMallModalStatus: action.payload.ourMallModalStatus,
})

const setCardListModalData = (state, action) => ({
  ...state,
  cardListModalData: action.payload.cardListModalData,
})

const setCardListModalStatus = (state, action) => ({
  ...state,
  showCardListModal: action.payload.cardListModalStatus !== null,
  cardListModalStatus: action.payload.cardListModalStatus,
})

const setPasyalArticles = (state, action) => ({
  ...state,
  pasyalArticles: action.payload.pasyalArticles,
})

const reducer = (state = INITIAL_STATE, action) => {
  const mutators = {
    [SET_HERO_BANNER]: setHeroBanner,
    [SET_HERO_BANNER_PROMOS_AND_EVENTS]: setHeroBannerPromosAndEvents,
    [SET_HERO_BANNERS]: setHeroBanners,
    [SET_FEATURED]: setFeatured,
    [SET_FEATURE_STATUS]: setFeatureStatus,
    [SET_OFFERS]: setOffers,
    [SET_PROMOS]: setPromos,
    [SET_EVENTS]: setEvents,
    [SET_MOVIES]: setMovies,
    [SET_MERCHANTS]: setMerchants,
    [SET_MALLS]: setMalls,
    [SET_CMS_MALLS]: setCMSMalls,
    [SET_MARKETING_CONTENT_DATA]: setMarketingContentModalData,
    [SET_MARKETING_CONTENT_STATUS]: setMarketingContentModalStatus,
    [SET_MERCHANTS_LIST_MODAL_DATA]: setMerchantsListModalData,
    [SET_STORE_MODAL_DATA]: setStoreModalData,
    [SET_DEVICE_LOCATION]: setDeviceLocation,
    [SET_CURRENT_MALL_IN_MODAL]: setCurrentMallInModal,
    [SET_OUR_MALL_MODAL_STATUS]: setOurMallModalStatus,
    [SET_CARD_LIST_MODAL_DATA]: setCardListModalData,
    [SET_CARD_LIST_MODAL_STATUS]: setCardListModalStatus,
    [SET_CINEMAS]: setCinemas,
    [SET_PASYAL_ARTICLES]: setPasyalArticles,
  }

  const { [action.type]: mutator = null } = mutators

  return typeof mutator === 'function' ? mutator(state, action) : state
}

export default reducer
